import React from "react";
import {
  CreateWorkflowViewerConfirmationContainer,
  HeaderContainer,
  HeaderTitle,
  HeaderSubtitle,
  ContentContainer,
  Title,
  InformationBoxContainer,
  InfoTitle,
  InfoContent,
  Bold,
  ButtonContainer,
} from "./createWorkflowViewerConfirmation.styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { Button } from "@ssce/ui-shared-library";
import SubdirectoryArrowLeftIcon from "@mui/icons-material/SubdirectoryArrowLeft";

export const CreateWorkflowViewerConfirmation: React.FC = () => {
  const navigate = useNavigate();

  return (
    <CreateWorkflowViewerConfirmationContainer>
      <HeaderContainer>
        <HeaderTitle>Workflow Created</HeaderTitle>
        <HeaderSubtitle>Setup now in Progress</HeaderSubtitle>
      </HeaderContainer>
      <ContentContainer>
        <CheckCircleIcon
          sx={{
            color: "#37B036",
            width: "132px",
            height: "132px",
          }}
        />
        <Title>Your Workflow has Been Created!</Title>
        <InformationBoxContainer>
          <InfoIcon
            width={"20px"}
            height={"20px"}
            sx={{ color: "#0A85C7", gridRow: "1/-1" }}
          />
          <div>
            <InfoTitle>What's Next?</InfoTitle>
            <InfoContent>
              <Bold>Workflow Setup in Progress: </Bold>Your workflow has been
              created and our team is finalizing the details. You can leave this
              page; your new workflow will appear in 'My Workflows' and be ready
              for editing or running once setup is complete.
            </InfoContent>
          </div>
        </InformationBoxContainer>
        <ButtonContainer>
          <Button
            id={"returnToWorkflowCatalog"}
            onClick={() => navigate("/workflow-catalog")}
            variant={"secondary"}
          >
            Return to Workflow Catalog <SubdirectoryArrowLeftIcon />
          </Button>
          <Button
            id={"goToMyWorkflows"}
            onClick={() => navigate("/my-workflows")}
            variant={"default"}
          >
            Go to My Workflows
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </CreateWorkflowViewerConfirmationContainer>
  );
};
